export default __webpack_public_path__ + "f11dc180fa3a17e913cd07299b9f4b7f.png";